import axios from 'axios';
import { navigateTo } from './navigation';

const api = axios.create({
  baseURL: '/api', // https://localhost:7152/api /api
  withCredentials: true, // for cookie-based auth
});


// Global 401 handler
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 || error.response?.status === 40) {
      navigateTo('/login');
    }
    return Promise.reject(error);
  }
);

export default api;
